import http from "src/services/http";
import queryString from "query-string";
import store from "src/store";
import * as types from "../types/cashback";

export const enviarPresente = ({
  cliente_id,
  empresa_id,
  qtde_dias,
  valor_cash,
  senha_liberacao,
  descricao,
}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/v2/empresa/presentes", {
        cliente_id,
        empresa_id,
        qtde_dias,
        valor_cash,
        senha_liberacao,
        descricao,
      })
      .then(
        (resp) => resolve(resp.data),
        (err) => reject(err)
      );
  });
};

export const enviarPresentes = (dados) => {
  store.dispatch({ type: types.CASHBACKS_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post("/api/v2/empresa/cashback/presentes/multiplus", dados).then(
      (resp) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        resolve(resp.data);
      },
      (err) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        reject(err);
      }
    );
  });
};

export const receberCashback = () => {
  const { cashback } = store.getState().cashback;
  store.dispatch({ type: types.CASHBACKS_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/empresa/cashback/receber`, cashback).then(
      (resp) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        resolve(resp.data);
      },
      (err) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        reject(err);
      }
    );
  });
};

export const enviarCashback = () => {
  const { cashback } = store.getState().cashback;
  store.dispatch({ type: types.CASHBACKS_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/empresa/cashback/enviar`, cashback).then(
      (resp) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        resolve(resp.data);
      },
      (err) => {
        store.dispatch({ type: types.CASHBACKS_LOADING, payload: false });
        reject(err);
      }
    );
  });
};

export const consultaSaldo = (cpf) => {
  return new Promise((resolve, reject) => {
    http.get(`/api/v2/empresa/cashback/usuarios/${cpf}`).then(
      (resp) => resolve(resp.data),
      (err) => reject(err)
    );
  });
};

export const pesquisarCashback = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/cashback?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;

        dispatch([
          { type: types.LOAD_CASHBACKS_LIST, payload: data },
          { type: types.SET_CASHBACKS_PAGE, payload: page },
          { type: types.SET_CASHBACKS_TOTAL, payload: total },
          { type: types.SET_CASHBACKS_PERPAGE, payload: per_page },
          { type: types.CASHBACKS_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.CASHBACKS_LOADING, payload: false }]);
      }
    );
  };
};

export const gerarExcel = (filtro) => {
  const qry = queryString.stringify({ ...filtro }, { arrayFormat: "index" });

  http
    .get(`/api/v2/empresa/cashback/exportar?${qry}`, {
      responseType: "arraybuffer",
    })
    .then((response) => {
      const file = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    });
};
